module.exports = __webpack_public_path__ + "img/summary.b342557d.svg";